export default "__VITE_ASSET__Bu84Nbxn__"